<template lang="pug">
  .field-transaction-id-and-date(v-if="$is('transaction-id')")
    .transaction-id TR{{item.id}}


  .field-transaction-id-and-date(v-else-if="$is('transaction-date')")
    .trasaction-date {{$dateFormat(item.created,$toMomentFormat(configuration.locale.locale_datetime_format.value))}}


  .field-transaction-client(v-else-if="$is('transaction-client')")
    router-link(:to="{name:'client', params:{id:item.client_id}}" )
      span(v-if="item.client_organization_name" ) {{item.client_organization_name}}
      span(v-else) {{item.name}} {{item.surname}}


  .field-transaction-payment-method(v-else-if="$is('transaction-payment-method')")
    .field-value PM{{item.payment_method_id}}
    .field-value {{item.payment_name}}
    .field-value {{item.payment_method_provider}}

  .field-transaction-created(v-else-if="$is('transaction-created')")
    .trasaction-date {{$dateFormat(item.created,$toMomentFormat(configuration.locale.locale_datetime_format.value))}}

  .field-transaction-amount(v-else-if="$is('transaction-amount')")
    .field(:style="item.amount < 0 ? 'color:#cc4b37':''") {{item.amount.toFixed(2)}}{{currency}}
  .field-transaction-status(v-else-if="$is('transaction-status')")
    p.label(:class="{alert:item.status !== 'SUCCESS'}") {{item.status}}
    p {{item.response.message}}

  .field-transaction-date(v-else-if="$is('transaction-date')")
    p {{$dateFormat(item.created,$toMomentFormat(configuration.locale.locale_datetime_format.value))}}

  .field-invoice-link(v-else-if="$is('invoice-link')")
    router-link(v-if="item.invoice.id", :to="{name:'invoice', params:{id:item.invoice.id}}" )
      span {{item.invoice.type}}{{item.invoice_internal_id}} ({{item.invoice_id}})
      //span(v-if="item.invoice_internal_id !== 0") INV{{item.invoice_internal_id}} ({{item.invoice_id}})
      //span(v-else) PROFORMA
    p(v-else) not invoiced yet
</template>
<script type="text/babel">
  import {mapState} from 'vuex'

  export default {
    name: "TransactionFields",
    components: {},
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      type() {
        return this.fieldName
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TransactionFields.vue?1c0c121e